const GradientSpinner = () => {
  return (
    <div className="flex justify-center items-center">
      <svg className="h-10 w-10 animate-spin" viewBox="0 0 50 50">
        <defs>
          <linearGradient
            id="spinnerGradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="#4F566B" />
            <stop offset="50%" stopColor="#4F566B8E" />
            <stop offset="100%" stopColor="#4F566B4D" />
          </linearGradient>
        </defs>
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke="url(#spinnerGradient)"
          strokeWidth="3"
          strokeLinecap="round"
          strokeDasharray="94.2 31.4"
          className="opacity-90"
        />
      </svg>
    </div>
  );
};

export default GradientSpinner;
